import React, { useState, useEffect } from "react";
import { Dialog, Slide, AppBar, Toolbar, CircularProgress } from "@material-ui/core";
import { generateForm } from "../../helpers/functions";
import axios from "axios";
import { toast } from "react-toastify";

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const AddUpdateStatuses = ({ visible, setVisible, formData, setFormData, getData }) => {
  const [saveIsLoading, setSaveIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { id, value, checked, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const saveForm = () => {
    setSaveIsLoading(true);
    const submitFormData = generateForm(formData);
    const url = formData.id > 0
      ? `${process.env.REACT_APP_API}/admin/statuses/update`
      : `${process.env.REACT_APP_API}/admin/statuses/add`;

    axios.post(url, submitFormData)
      .then(() => {
        toast.success(formData.id > 0 ? "Updated successfully" : "Inserted successfully");
        setSaveIsLoading(false);
        setVisible(false);
        getData();
      })
      .catch(() => {
        setSaveIsLoading(false);
        toast.error("Error While Saving");
      });
  };

  const handleClose = () => setVisible(false);

  return (
    <Dialog fullScreen open={visible} onClose={handleClose} TransitionComponent={Transition} style={{ zIndex: 2235 }}>
      <AppBar className="position-relative">
        <Toolbar>
          <button type="button" className="close-modal-button" onClick={handleClose}>&times;</button>
          <h4 className="text-white mx-3 my-0">{formData.id > 0 ? "Update" : "Add"}</h4>
        </Toolbar>
      </AppBar>
      <div style={{ padding: "25px" }}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" className="form-control" id="name" onChange={handleInputChange} value={formData.name} />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="color">Color</label>
              <input type="color" className="form-control" id="color" onChange={handleInputChange} value={formData.color} />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group" style={{ padding: "20px" }}>
              <input className="form-control-checkbox" id="isFinal" type="checkbox" checked={formData.isFinal == 1} onChange={handleInputChange} />
              <label style={{ paddingLeft: 10 }} htmlFor="isFinal">Is Final</label>
            </div>
          </div>

          <div className="col-sm-12 mt-5">
            {saveIsLoading ? (
              <CircularProgress />
            ) : (
              <button className="btn btn-md btn-primary float-end" onClick={saveForm}>Save</button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddUpdateStatuses;
